import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=0baa58bd&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=js&"
export * from "./auth.vue?vue&type=script&lang=js&"
import style0 from "./auth.vue?vue&type=style&index=0&id=0baa58bd&prod&scoped=true&lang=css&"
import style1 from "./auth.vue?vue&type=style&index=1&id=0baa58bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa58bd",
  null
  
)

export default component.exports